/* ROUTE CONSTANTS
   ========================================================================== */

const ROUTES = {
  homePage: '/',
  notfound: '*',
  login: '/login',
  signup: '/signup',
  forgotpassword: '/forgot-password',
  parish: '/parish-information/parish', // thông tin giáo xứ
  subParish: '/parish-information/sub-parish', // thông tin giáo họ
  priest: '/parish-information/priest', // thông tin linh mục
  parishioner: '/community-management/parishioner', // quản lý giáo dân
  family: '/community-management/family' // quản lý gia đình
}

export default ROUTES
